function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.7992 3.2002H1.19922M13.4656 5.2002L13.0976 10.7202C12.956 12.8434 12.8856 13.905 12.1936 14.5522C11.5016 15.1994 10.4368 15.2002 8.30882 15.2002H7.68962C5.56162 15.2002 4.49682 15.2002 3.80482 14.5522C3.11282 13.905 3.04162 12.8434 2.90082 10.7202L2.53282 5.2002M5.99922 7.2002L6.39922 11.2002M9.99922 7.2002L9.59922 11.2002",
    stroke: "#99ABA7",
    style: {
      stroke: "#99ABA7",
      stroke: "color(display-p3 0.6000 0.6706 0.6549)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 3.1998H3.68761C4.00957 3.19158 4.32155 3.08638 4.58275 2.89797C4.84395 2.70957 5.04221 2.44672 5.15161 2.1438L5.17881 2.0614L5.25641 1.8286C5.32281 1.6294 5.35641 1.5302 5.40041 1.4454C5.48698 1.27932 5.61122 1.1358 5.76319 1.02633C5.91516 0.916866 6.09065 0.844493 6.27561 0.815005C6.36921 0.799805 6.47401 0.799805 6.68361 0.799805H9.31561C9.52521 0.799805 9.63001 0.799805 9.72361 0.815005C9.90857 0.844493 10.0841 0.916866 10.236 1.02633C10.388 1.1358 10.5122 1.27932 10.5988 1.4454C10.6428 1.5302 10.6764 1.6294 10.7428 1.8286L10.8204 2.0614C10.9218 2.39842 11.1315 2.69261 11.417 2.89841C11.7024 3.10422 12.0478 3.21015 12.3996 3.1998",
    stroke: "#99ABA7",
    style: {
      stroke: "#99ABA7",
      stroke: "color(display-p3 0.6000 0.6706 0.6549)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/deleteGrey.499d3f14eeeda0b210d0ff475a38347e.svg";
export { ForwardRef as ReactComponent };